import styled from 'styled-components';

var FieldRoot = styled.div.withConfig({
  displayName: "Field__FieldRoot",
  componentId: "sc-dtefz7-0"
})(["width:100%;"]);
styled.div.withConfig({
  displayName: "Field__FieldErrorContainer",
  componentId: "sc-dtefz7-1"
})(["display:flex;align-items:flex-start;"]);

export { FieldRoot };
